export default {
  // 火灾设备
  fireType: {
    deviceType: 1,
    deviceRoute: 'fire_detail',
    historyRoute: 'fire_history',
    alarmRoute: 'fire_alarm'
  },
  // 空开设备
  cbType: {       // 火灾设备
    deviceType: 2,
    deviceRoute: 'cb_detail',
    historyRoute: 'cb_history',
    alarmRoute: 'cb_alarm'
  },


  // 报警日志过滤类型
  warningLogListFilterType: [
    {
      label: '全部类型',
      value: ''
    },
    {
      label: '过欠压',
      value: 1,
      unit: 'V'
    },
    {
      label: '过载',
      value: 2,
      unit: 'A'
    },
    {
      label: '超温',
      value: 3,
      unit: '°C'
    },
    {
      label: '漏电',
      value: 4,
      unit: 'mA'
    },
    {
      label: '烟雾',
      value: 5,
      unit: ''
    },
    {
      label: '可燃气浓度',
      value: 6,
      unit: ''
    },
    {
      label: "烟感",
      value: 7
    },
    {
      label: '电弧',
      value: 8
    },
    {
      label: '联动',
      value: 9
    }
  ],
  historyDataListFilterType: [
    {
      label: '全部类型',
      value: ''
    },
    {
      label: '电流',
      value: '2'
    },
    {
      label: '电压',
      value: '4'
    },
    {
      label: '温度',
      value: '3'
    },
    {
      label: '烟雾',
      value: '5'
    },
    {
      label: '电度',
      value: '-1'
    },
    {
      label: '有功功率',
      value: '-2'
    },
    {
      label: '功率因素',
      value: '-3'
    },
    {
      label: '电弧',
      value: '-4'
    },
    {
      label: '剩余电流',
      value: '1'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/common/config.js